import Vue from 'vue';
import ElementHeadlineBig from '../components/element/headline--big.vue';
import ElementHeadlineSmall from '../components/element/headline--small.vue';
import ElementStatusled from '../components/element/statusled.vue';
import ElementText from '../components/element/text.vue';
import ElementList from '../components/element/list.vue';
import ElementSetting from '../components/element/setting.vue';
import ElementInputtext from '../components/element/inputtext.vue';
import ElementLoader from '../components/element/loader.vue';
import ElementProgress from '../components/element/progress.vue';
import ElementMedia from '../components/element/media.vue';
import ElementButton from '../components/element/button.vue';
import ElementSubIcon from '../components/elementSub/icon.vue';
import ElementSpinner from '../components/elementSub/spinner.vue';
import ElementSubInput from '../components/elementSub/input.vue';
import ElementDateTime from '../components/elementSub/dateTime.vue';

import ElementDownloadButton from '../components/element/downloadButton.vue';

import ElementDownloadProgress from '../components/element/downloadProgress.vue';

export default function () {
	Vue.component('ElementButton', ElementButton);
	Vue.component('ElementDownloadButton', ElementDownloadButton);
	Vue.component('ElementDownloadProgress', ElementDownloadProgress);
	Vue.component('ElementHeadlineBig', ElementHeadlineBig);
	Vue.component('ElementHeadlineSmall', ElementHeadlineSmall);
	Vue.component('ElementStatusled', ElementStatusled);
	Vue.component('ElementText', ElementText);
	Vue.component('ElementList', ElementList);
	Vue.component('ElementSetting', ElementSetting);
	Vue.component('ElementInputtext', ElementInputtext);
	Vue.component('ElementLoader', ElementLoader);
	Vue.component('ElementProgress', ElementProgress);
	Vue.component('ElementMedia', ElementMedia);
	Vue.component('ElementSubIcon', ElementSubIcon);
	Vue.component('ElementSubInput', ElementSubInput);
	Vue.component('ElementDateTime', ElementDateTime);
	Vue.component('ElementSpinner', ElementSpinner);
}
